import { FloatButton } from "antd";
import { UnorderedListOutlined } from "@ant-design/icons";

export const layoutStruct = {
  style: { minHeight: "100vh" },
};

export const siderStruct = {
  theme: "light",
  breakpoint: "lg",
  collapsedWidth: "0",
  width: 300,
  trigger: <FloatButton type="primary" icon={<UnorderedListOutlined />} />,
  reverseArrow: true,
};

export const siderMenuIcon = {
  home: "HomeOutlined",
  user: "UserOutlined",
  book: "BookOutlined",
  form: "FormOutlined",
  edit: "EditOutlined",
  copy: "CopyOutlined",
};

export const siderMenuStruct = {
  mode: "inline",
  style:{
    position: "relative"
  }
};

export const headerStruct = {
  header: {
    wrap: "wrap",
    gap: "middle",
    justify: "space-between",
    align: "center",
    padding: 0,
    margin: 0,
  },

  userInfo: {
    user: {
      style: {
        display: "flex",
        flexDirection: "column",
        border: 0,
        borderRadius: 0,
        borderBottom: "1px solid #dadada",
      }
    },

    userEmail:{
      style:{
        display: "flex",
        alignItems: "center",
        gap: "10px"
      }
    },

    userTitle: {
      level: 4,
    },
    userSemiTitle: {
      level: 5,
    },
    userText: {
      type: "secondary",
      strong: true,
    },
  },

  actions: {
    gap: "middle",
    wrap: "wrap",
  },
};

export const contentStruct = {
  style: {
    margin: "0px 24px",
    minHeight: 280,
  },
};

export const signOutButtonStruct = {
  type: "primary",
  danger: true,
};



